document.addEventListener("DOMContentLoaded", () => {
  //let item_body = document.querySelector('body');
  checkElement("body").then((element) => {
    let ad_gates = element.querySelector(".ad-gates");
    if (ad_gates) {
      element.classList.add("ad-gates-pushdown");
    }
  });

  navbarSearch();
});

//Use requestAnimationFrame to detect if element is 100% loaded in DOM
const checkElement = async (selector) => {
  while (document.querySelector(selector) === null) {
    await new Promise((resolve) => requestAnimationFrame(resolve));
  }
  return document.querySelector(selector);
};
/* **************************************************************** */

const navbarSearch = () => {
  let search_trigger = document.querySelector(".top-search-trigger");
  let search_input_wrapper = document.querySelector(".top-search-form-wrapper");
  let search_form = search_input_wrapper.querySelector("form");
  let search_form_input = search_form.querySelector(
    ".js-form-type-search input"
  );

  function toggleSearch() {
    search_input_wrapper.classList.add("top-search-active");
    search_trigger.removeEventListener("click", toggleSearch);

    search_trigger.addEventListener("click", submitSearch);
  }

  function submitSearch() {
    search_form.submit();
  }

  search_trigger.addEventListener("click", toggleSearch);

  document.addEventListener("click", (e) => {
    if (e.target !== search_trigger && e.target !== search_form_input) {
      search_input_wrapper.classList.remove("top-search-active");
      search_trigger.addEventListener("click", toggleSearch);
      search_trigger.removeEventListener("click", submitSearch);
    }
  });
};
